module.exports = __webpack_public_path__ + "img/liulianbanjian.686db691.jpg";